<template>
  <div id="app">
    <Calibration />
  </div>
</template>

<script>
import Calibration from "./components/Calibration.vue";

export default {
  name: "App",
  components: {
    Calibration
  }
};
</script>

<style lang="scss">
@font-face {
  font-family: "TT Norms";
  src: local("TT Norms Regular"), local("TT-Norms-Regular"),
    url("assets/fonts/TTNorms-Regular.woff2") format("woff2"),
    url("assets/fonts/TTNorms-Regular.woff") format("woff"),
    url("assets/fonts/TTNorms-Regular.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

#app {
  font-family: "TT Norms", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
  font-size: 16px;
  line-height: 24px;
}

input[type="checkbox"]:focus,
input[type="radio"]:focus {
  visibility: hidden;
}

:focus,
:active,
:hover {
  outline-style: none;
  outline-width: 0px !important;
  outline-color: none !important;
}

.row,
p {
  margin: 0;
}

.col {
  padding: 0;
}
</style>
